import { createSlice } from '@reduxjs/toolkit';
import { getEstimatedTax } from './estimated-tax.thunks';
import { EstimatedTax, EstimatedTaxState } from './estimated-tax.interface';
import { defaultApiState } from '../../common/constants/api-constants';
import { ActionStatus } from '../../common/constants/action-status';
import { ShopCartUrlContext } from '../../common/utils/cart-util';
import { getResponseData } from '../../common/utils/api-utils';
import environment from '../../common/environment';
import { ShopApi, getGuestEstimatedTaxMagento } from '../../common/constants/shop-api';
import { mapMagentoTaxResponseToEstimatedTax } from './estimated-tax.mapping';

/*----- CREATE INITIAL STATE ------*/

export const estimatedTaxStateInitialState: EstimatedTaxState = defaultApiState;

/*----- CREATE STORE SLICE ------*/

export const estimatedTaxSlice = createSlice({
  name: 'estimatedTax',
  initialState: estimatedTaxStateInitialState,
  reducers: {
    updateEstimatedTaxStatus(state, action) {
      state.status = ActionStatus[action.payload];
    }
  },
  extraReducers(builder) {
    builder
      .addCase(getEstimatedTax.pending, (state) => {
        state.status = ActionStatus.loading;
      })
      .addCase(getEstimatedTax.fulfilled, (state, action) => {
        state.status = ActionStatus.succeeded;
        state.data = action.payload;
        state.error = undefined;
      })
      .addCase(getEstimatedTax.rejected, (state, action: any) => {
        state.status = ActionStatus.failed;
        state.error = action.payload.error;
        state.data = {
          totalTax: {
            amount: undefined,
            currency: undefined
          },
          zipCode: action.payload.zipCode
        };
      });
  }
});
/*----- CREATE SLICE ACTIONS ------*/

export const { updateEstimatedTaxStatus } = estimatedTaxSlice.actions;
/*----- CREATE REDUCER ------*/

export const estimatedTaxReducer = estimatedTaxSlice.reducer;


/*----- API CALLS ------*/

export async function getGuestEstimatedTaxMagentoApiCall(guestCartToken: string, cartContext: ShopCartUrlContext): Promise<EstimatedTax> {
  const url =  new URL(environment().magentoUrl + getGuestEstimatedTaxMagento(guestCartToken));

  const res = await getResponseData(
    new Request(url.toString(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        "zipCode": cartContext.zipCode
      })
    }));
    return mapMagentoTaxResponseToEstimatedTax(res);
}

export async function getLoggedInEstimatedTaxMagentoApiCall(token: string, cartContext: ShopCartUrlContext): Promise<EstimatedTax> {
  const url =  new URL(environment().magentoUrl + ShopApi.getLoggedInEstimatedTaxMagento);

  const res = await getResponseData(
    new Request(url.toString(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization' : `Bearer ${token}`
      },
      body: JSON.stringify({
        "zipCode": cartContext.zipCode
      })
    }));
    return mapMagentoTaxResponseToEstimatedTax(res);
}
